import { Flex } from '@mantine/core';
import { useState } from 'react';
import { IconPlus } from '@tabler/icons-react';
import ManualRunModal from '@/pages/AutomationPage/components/ManualRunModal/ManualRunModal.tsx';
import StyledButton from '@/components/StyledButton/StyledButton.tsx';
import { Automation } from '@/types/automations.ts';

type props = {
  automation?: Automation;
};

const RunHistoryManualRunButton = ({ automation }: props) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Flex w={'100%'} mt={'sm'} mb={'4px'} px={'sm'}>
      <StyledButton
        variant={'grey'}
        size={'md'}
        leftSection={<IconPlus size={14} stroke={2} />}
        onClick={() => setShowModal(true)}
        w={'100%'}
        styles={{ section: { marginRight: 5 } }}
      >
        New Run
      </StyledButton>

      <ManualRunModal
        opened={showModal}
        onClose={() => setShowModal(false)}
        automation={automation}
      />
    </Flex>
  );
};

export default RunHistoryManualRunButton;
